import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "about"
    }}>{`About`}</h1>
    <p>{`MDX is based on the `}<a parentName="p" {...{
        "href": "https://spectrum.chat/thread/1021be59-2738-4511-aceb-c66921050b9a"
      }}>{`original `}<inlineCode parentName="a">{`.mdx`}</inlineCode>{` proposal`}</a>{` by Guillermo Rauch
(`}<a parentName="p" {...{
        "href": "https://twitter.com/rauchg"
      }}>{`@rauchg`}</a>{`).  It’s syntax is defined by an official `}<a parentName="p" {...{
        "href": "https://github.com/mdx-js/specification"
      }}>{`specification`}</a>{`.
The source code for MDX is available on `}<a parentName="p" {...{
        "href": "https://github.com/mdx-js/mdx"
      }}>{`GitHub`}</a>{` and is `}<a parentName="p" {...{
        "href": "https://github.com/mdx-js/mdx/blob/master/license"
      }}>{`MIT licensed`}</a>{`.`}</p>
    <p>{`The project is governed by the `}<a parentName="p" {...{
        "href": "https://github.com/unifiedjs/governance"
      }}>{`unified collective`}</a>{`.`}</p>
    <h3 {...{
      "id": "design"
    }}>{`Design`}</h3>
    <p><a parentName="p" {...{
        "href": "https://github.com/mdx-js/design"
      }}>{`Logo designs`}</a>{` were created by `}<a parentName="p" {...{
        "href": "https://twitter.com/evilrabbit_"
      }}>{`Evil Rabbit`}</a>{`) of `}<a parentName="p" {...{
        "href": "https://zeit.co"
      }}>{`ZEIT`}</a>{` and are also
available on `}<a parentName="p" {...{
        "href": "https://github.com/mdx-js/design"
      }}>{`GitHub`}</a>{`.`}</p>
    <h3 {...{
      "id": "authors"
    }}>{`Authors`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://johno.com"
        }}>{`John Otander`}</a>{` (`}<a parentName="li" {...{
          "href": "https://twitter.com/4lpine"
        }}>{`@4lpine`}</a>{`) – `}<a parentName="li" {...{
          "href": "https://compositor.io"
        }}>{`Compositor`}</a>{` + `}<a parentName="li" {...{
          "href": "https://clearbit.com"
        }}>{`Clearbit`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/timneutkens"
        }}>{`Tim Neutkens`}</a>{` (`}<a parentName="li" {...{
          "href": "https://twitter.com/timneutkens"
        }}>{`@timneutkens`}</a>{`) – `}<a parentName="li" {...{
          "href": "https://zeit.co"
        }}>{`ZEIT`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://rauchg.com"
        }}>{`Guillermo Rauch`}</a>{` (`}<a parentName="li" {...{
          "href": "https://twitter.com/rauchg"
        }}>{`@rauchg`}</a>{`) – `}<a parentName="li" {...{
          "href": "https://zeit.co"
        }}>{`ZEIT`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://jxnblk.com"
        }}>{`Brent Jackson`}</a>{` (`}<a parentName="li" {...{
          "href": "https://twitter.com/jxnblk"
        }}>{`@jxnblk`}</a>{`) – `}<a parentName="li" {...{
          "href": "https://compositor.io"
        }}>{`Compositor`}</a></li>
    </ul>
    <h2 {...{
      "id": "related"
    }}>{`Related`}</h2>
    <p>{`The following projects, languages, and articles helped to shape MDX either in
implementation or inspiration.`}</p>
    <p>{`Is your work missing?
If you have related work or prior art we’ve failed to reference, please open a
PR!`}</p>
    <h3 {...{
      "id": "syntax"
    }}>{`Syntax`}</h3>
    <p>{`These projects define the syntax which MDX blends together (MD and JSX).`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://daringfireball.net/projects/markdown/syntax"
        }}>{`Markdown`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://reactjs.org/docs/introducing-jsx.html"
        }}>{`JSX`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://reactjs.org/"
        }}>{`React`}</a></li>
    </ul>
    <h3 {...{
      "id": "parsing-and-implementation"
    }}>{`Parsing and implementation`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://remark.js.org"
        }}>{`remark`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://unified.js.org"
        }}>{`unified`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://babeljs.io"
        }}>{`babel`}</a></li>
    </ul>
    <h3 {...{
      "id": "libraries"
    }}>{`Libraries`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/jamesknelson/mdxc"
        }}>{`MDXC`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ticky/markdown-component-loader"
        }}>{`Markdown Component Loader`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/threepointone/markdown-in-js"
        }}>{`markdown-in-js`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/fazouane-marouane/remark-jsx"
        }}>{`remark-jsx`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/mapbox/remark-react"
        }}>{`remark-react`}</a></li>
    </ul>
    <h3 {...{
      "id": "other"
    }}>{`Other`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/iainc/Markdown-Content-Blocks"
        }}>{`IA Markdown Content Blocks`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://idyll-lang.org"
        }}>{`Idyll: Markup language for interactive documents`}</a></li>
    </ul>

    </MDXLayout>;
}
MDXContent.isMDXComponent = true;
      